import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {countries, devConfig} from "config/config"; // Importing countries and devConfig from the configuration file

/**
 * Class representing a view for filtering partner products.
 * @extends JetView
 */
export default class FilterPartnersProductsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing filters
        const left = {
            margin: 5,
            rows: [{
                margin: 15,
                css: "on-row",
                cols: [
                    {
                        view: "combo", name: "ProviderId", // Combo box for selecting provider
                        localId: "provider:combo",
                        label: _("Proveedor"), labelPosition: "top",
                        placeholder: _("Click para seleccionar "),
                        options: {
                            body: {
                                dataFeed: function (text) { // Function to fetch provider data
                                    var vthis = this; // Preserve context
                                    if (text.length > 2) { // Trigger data fetch if input length is greater than 2
                                        webix.ajax().headers({
                                            "Content-type": "application/json"
                                        }).post(devConfig.geturlApi() + "es/Select/ProvidersCredentialsSelect", '{"Filter":"' + text + '"}', {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message("Error! "); // Error message on failure
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var resp = JSON.parse(text); // Parse response
                                                if (!resp.HasError) {
                                                    vthis.parse(resp.Data); // Populate combo with data
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    },
                    {
                        view: "combo", name: "SubProviderId", // Combo box for selecting sub-provider
                        localId: "subProvider:combo",
                        label: _("Sub Proveedor"), labelPosition: "top",
                        placeholder: _("Click para seleccionar "),
                        options: {
                            body: {
                                dataFeed: function (text) { // Function to fetch sub-provider data
                                    var vthis = this; // Preserve context
                                    if (text.length > 2) { // Trigger data fetch if input length is greater than 2
                                        webix.ajax().headers({
                                            "Content-type": "application/json"
                                        }).post(devConfig.geturlApi() + "es/Select/SubProvidersCredentialsSelect", '{"Filter":"' + text + '"}', {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message("Error! "); // Error message on failure
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var resp = JSON.parse(text); // Parse response
                                                if (!resp.HasError) {
                                                    vthis.parse(resp.Data); // Populate combo with data
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    },
                    {
                        view: "richselect", name: "CountrySelect", id: "CountrySelect", minWidth: 200, // Rich select for country selection
                        localId: "regions:combo",
                        label: "<span class='icon-language'></span>" + _("País"), labelPosition: "top",
                        placeholder: _("Click para seleccionar "),
                        options: {
                            body: {
                                template: function (obj) { // Template for displaying country with flag
                                    return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                },
                                data: countries // Data source for countries
                            }
                        }
                    },
                ]
            },
            {
                margin: 15,
                css: "on-row",
                cols: [
                    {
                        view: 'combo',
                        name: 'Type',
                        minWidth: 200,
                        id: 'Type',
                        label: _('Tipo'), // Label for type selection
                        labelPosition: 'top',
                        options: [],
                        placeholder: _('Click para seleccionar '),
                    },
                    {
                        view: "richselect", name: "IsActivate", // Rich select for activation status
                        label: "<span class='icon-state'></span>" + _("Estado"), labelPosition: "top",
                        placeholder: _("Click para seleccionar "),
                        options: [
                            {"id": "null", "value": _("Todos")},
                            {"id": "A", "value": _("Activado")},
                            {"id": "I", "value": _("Inactivado")}
                        ]
                    },
                    {id: "grav", gravity: 1}, // Gravity element for layout
                    {id: "grav", gravity: 1} // Gravity element for layout
                ]
            }]
        };

        // Upper section containing filters and buttons
        const upper_section = {
            css: "father-container", height: (document.body.offsetWidth < 500) ? 250 : 0,
            rows: [{
                margin: 10,
                cols: [
                    left, // Include left section
                ]
            }]
        };

        // Buttons section for actions
        const buttons = {
            id: "b2",
            rows: [{
                margin: 10,
                responsive: "b2",
                cols: [
                    {id: "grav", gravity: 4}, // Gravity element for layout
                    {
                        view: "button", value: _("Limpiar"), width: (screen == "small") ? 0 : 100, minWidth: 200, // Clear button
                        click: () => {
                            this.getRoot().clear(); // Clear the form
                        }
                    },
                    {
                        id: "buttonSubmit",
                        view: "button", // Submit button
                        value: _("Consultar"),
                        disabled: false,
                        type: "form",
                        width: (screen == "small") ? 0 : 100,
                        minWidth: 200,
                        click: () => {
                            const filterdata = this.getRoot().getValues(); // Get form values
                            this.app.callEvent("partnerCredentialsSubProvider:filter", [filterdata]); // Trigger filter event
                            $$("b1").collapse(); // Collapse the accordion
                            $$('a5').scrollTo(100, 0); // Scroll to a specific position
                        }
                    }
                ]
            }]
        };

        // Accordion section containing filters
        const accordion_section1 = {
            type: "wide",
            rows: [
                {
                    multi: true,
                    view: "accordion",
                    css: "betShop",
                    collapsed: true,
                    type: "clean",
                    rows: [
                        {
                            header: _("Filtros"), id: "b1", body: {
                                padding: 10,
                                rows: [upper_section, buttons] // Include upper section and buttons
                            }
                        }
                    ]
                }
            ]
        };

        // Return the main configuration for the form
        return {
            view: "form",
            type: "clean",
            rows: [
                accordion_section1 // Include accordion section
            ],
            rules: {
                "fname": webix.rules.isNotEmpty // Validation rule for form
            }
        };
    }

    /**
     * Initializes the view after it is rendered.
     * @param {Object} grid - The grid object passed to the init function.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) { // Check screen width for responsive design
                $$("grav").hide(); // Hide elements based on screen size
                $$("grav2").hide(); // Hide elements based on screen size
            }
        });

        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'PartnersSubProviders/GetTypeSubProviders', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message(_('Error! ')); // Error message on AJAX failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(text);
                    var optionsTypes = $$('Type').getList();
                    optionsTypes.clearAll(); // Clear existing options
                    optionsTypes.parse(data.data); // Parse and set new options
                    setTimeout(() => {
                        $$('Type').setValue('1'); // Set default value after a short delay
                    }, 10);
                },
            });
    }
}

// FILE DOCUMENTED
